/**
 * Formats a cash-game buy-in amount for the lobby tile.
 *
 * Large amounts are abbreviated so they fit the narrow tile (e.g. 1000 → "$1K",
 * 1500 → "$1.5K", 2_000_000 → "$2M") — the previous raw "$1,000" was clipped to
 * "$1" by the tile width. Amounts below 1,000 are left as-is so micro-stakes
 * buy-ins keep their cents (e.g. 0.2 → "$0.2", 100 → "$100").
 */
const trimUnit = (value: number): string => (value % 1 === 0 ? String(value) : value.toFixed(1));

export const formatBuyIn = (amount: number): string => {
  if (!Number.isFinite(amount) || amount < 0) return '$0';
  if (amount >= 1_000_000) return `$${trimUnit(amount / 1_000_000)}M`;
  if (amount >= 1_000) return `$${trimUnit(amount / 1_000)}K`;
  return `$${amount}`;
};
